import { brandStorage as localStorage } from '@/utils/brandSession';
import React from 'react';

/**
 * Error Boundary generico per catturare QUALSIASI errore di rendering.
 * Quando un errore non gestito si verifica (es: schermata bianca),
 * preserva la sessione e permette di riprovare o tornare al login corretto.
 */
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[AppErrorBoundary] Errore catturato:', error.message);
    console.error('[AppErrorBoundary] Stack:', errorInfo?.componentStack);
  }

  isHomeSmartContext = () => {
    const path = window.location.pathname || '';
    const params = new URLSearchParams(window.location.search || '');
    if (path.startsWith('/home-smart') || params.has('wallet') || params.has('white_label')) return true;
    try {
      const user = JSON.parse(localStorage.getItem('hw_user') || 'null');
      if (user?.is_external_tenant) return true;
    } catch (_) {}
    return localStorage.getItem('home_smart_context') === 'true';
  };

  handleRetry = () => window.location.reload();

  handleLogin = () => {
    window.location.href = this.isHomeSmartContext() ? '/home-smart/accedi' : '/login';
  };

  render() {
    if (this.state.hasError) {
      const isHomeSmart = this.isHomeSmartContext();
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8fafc',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          <div style={{ textAlign: 'center', padding: '2rem', maxWidth: '400px' }}>
            <div style={{
              width: '60px', height: '60px', borderRadius: '50%',
              background: '#fee2e2', display: 'flex', alignItems: 'center',
              justifyContent: 'center', margin: '0 auto 1.5rem'
            }}>
              <span style={{ fontSize: '24px', color: '#dc2626' }}>!</span>
            </div>
            <h2 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1e293b', margin: '0 0 0.5rem' }}>
              Si è verificato un errore
            </h2>
            <p style={{ color: '#64748b', margin: '0 0 1.5rem', fontSize: '0.875rem' }}>
              {isHomeSmart ? 'Home Smart ha riscontrato un problema temporaneo. La tua sessione è stata conservata.' : 'L’applicazione ha riscontrato un problema temporaneo. La tua sessione è stata conservata.'}
            </p>
            <button
              onClick={this.handleRetry}
              data-testid="error-boundary-retry-button"
              style={{
                padding: '0.75rem 2rem',
                background: '#1e40af',
                color: 'white',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: '500'
              }}
            >
              Riprova
            </button>
            <button onClick={this.handleLogin} style={{ display: 'block', width: '100%', marginTop: '0.75rem', padding: '0.7rem 1rem', background: 'transparent', color: '#1e40af', border: '1px solid #93c5fd', borderRadius: '0.5rem', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600' }} data-testid="error-boundary-login-button">{isHomeSmart ? 'Vai all’accesso Home Smart' : 'Torna al login HWsmart'}</button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
